export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/22ecc9ffe87e543de051ed029029bbad.jpg" 
          alt="Premium Flooring Installation"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight tracking-tight">
            TRANSFORMING SPACES THROUGH PRECISION FLOORING SOLUTIONS
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-10 font-light">
            Premier Commercial & Residential Flooring | Licensed & Insured in Florida
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="#contact" className="px-8 py-4 bg-[#FF6B35] text-white text-base font-semibold rounded-full hover:bg-[#FF6B35]/90 transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer">
              <span>REQUEST FREE CONSULTATION</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
            <a href="#services" className="px-8 py-4 border-2 border-[#2E5C8A] text-white text-base font-semibold rounded-full hover:bg-[#2E5C8A] transition-all whitespace-nowrap cursor-pointer">
              VIEW SERVICES
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 bg-gray-900/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center md:text-left">
            <div className="text-white">
              <p className="text-3xl font-bold text-[#FF6B35]">15+</p>
              <p className="text-sm font-medium">Years Experience</p>
            </div>
            <div className="text-white">
              <p className="text-3xl font-bold text-[#FF6B35]">500+</p>
              <p className="text-sm font-medium">Projects Completed</p>
            </div>
            <div className="text-white">
              <p className="text-3xl font-bold text-[#FF6B35]">6-Month</p>
              <p className="text-sm font-medium">Installation Warranty</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
